// extracted by mini-css-extract-plugin
module.exports = {"error":"_2m3MVNqH"};